module.exports = __webpack_public_path__ + "img/sert3.0e9ef227.png";